module.exports = __webpack_public_path__ + "img/IMG-20200714-WA0008.48693571.jpg";